import useSWR from 'swr';
import type { SplitChallengeResponse } from '@youga/youga-interfaces';
import { useYougaClientApi } from '../YougaClientApiProvider';

export function useSplitChallenge() {
  const { fetcher } = useYougaClientApi();
  return useSWR<SplitChallengeResponse>('/live/split-challenge', {
    fetcher,
    dedupingInterval: 30_000,
    refreshInterval: 60_000,
  });
}
